export const sliceText = (text, sliceNumber = 20) => {
  if (!text) return null;
  if (text.length < sliceNumber) {
    return text;
  } else {
    return text.slice(0, sliceNumber) + "...";
  }
};
